import {RepoStacksSort} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {useNavigate, useSearchParams} from '@github-ui/use-navigate'
import {SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import type {StacksSort} from '../../routes/repo-stacks-list-route'

type SortOption = {value: StacksSort; sort: RepoStacksSort; label: string}

const NEWEST: SortOption = {value: 'newest', sort: RepoStacksSort.NEWEST, label: 'Newest'}
const SORT_OPTIONS: SortOption[] = [NEWEST, {value: 'oldest', sort: RepoStacksSort.OLDEST, label: 'Oldest'}]

export function StacksSortMenu({basePath, sort}: {basePath: string; sort: RepoStacksSort}) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const selected = SORT_OPTIONS.find(option => option.sort === sort) ?? NEWEST

  const selectSort = (value: StacksSort) => {
    const params = new URLSearchParams(searchParams)
    params.delete('page')
    if (value === 'newest') {
      params.delete('sort')
    } else {
      params.set('sort', value)
    }
    const search = params.toString()
    navigate(search ? `${basePath}?${search}` : basePath)
  }

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" leadingVisual={SortDescIcon} aria-label={`Sort by ${selected.label}`}>
        Sort
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          <ActionList.Group>
            <ActionList.GroupHeading>Sort by</ActionList.GroupHeading>
            {SORT_OPTIONS.map(option => (
              <ActionList.Item
                key={option.value}
                role="menuitemradio"
                selected={option.sort === selected.sort}
                onSelect={() => selectSort(option.value)}
              >
                {option.label}
              </ActionList.Item>
            ))}
          </ActionList.Group>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
